import type { ReactNode } from 'react';
import { C } from '../theme';
import { Icon } from '../icons';

export type RowTone = 'br' | 'ac' | 'rd';

/** The list row used across the tenant home / statement (ported from prototype). */
export function Row({
  icon,
  tone,
  t,
  s,
  r,
  chev,
  onClick,
}: {
  icon: string;
  tone: RowTone;
  t: string;
  s: string;
  r?: ReactNode;
  chev?: boolean;
  onClick?: () => void;
}) {
  const tones = {
    br: [C.amberSoft, '#7a5518'],
    ac: [C.soft, C.accent2],
    rd: [C.redSoft, C.red],
  } as const;
  const [bg, fg] = tones[tone];
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 11,
        padding: '10px 14px',
        borderTop: `1px solid ${C.line2}`,
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <span style={{ width: 30, height: 30, borderRadius: 8, background: bg, color: fg, display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}>
        <Icon n={icon} size={15} />
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <b style={{ fontSize: 13.3, color: C.ink, fontWeight: 600, display: 'block' }}>{t}</b>
        <small style={{ fontSize: 12, color: C.muted }}>{s}</small>
      </div>
      {r ? (
        <span style={{ fontFamily: 'ui-monospace, Menlo, monospace', fontVariantNumeric: 'tabular-nums', fontSize: 12.8, fontWeight: 600, color: C.ink }}>{r}</span>
      ) : chev ? (
        <Icon n="chev" size={15} color={C.muted} />
      ) : null}
    </div>
  );
}
